import { defineMessages } from 'react-intl';

export const messages: {
	authorizationFail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	authorizationSuccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectThirdPartyProductTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectThirdPartyProductTitleAlternate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectThirdPartyProductDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	softBannerTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	softBannerDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	authorizationFail: {
		id: 'oauth-banner.authorization-fail',
		defaultMessage: 'Failed to connect to {product}.',
		description: 'Message displayed when authorization fails.',
	},
	authorizationSuccess: {
		id: 'oauth-banner.authorization-success',
		defaultMessage: 'Account connected to {product}.',
		description: 'Message displayed when authorization is successful.',
	},
	connectThirdPartyProductTitle: {
		id: 'connect_third_party_product_title',
		defaultMessage: 'Your admin has added {product}!',
		description: 'Title shown to prompt users to connect third-party products',
	},
	connectThirdPartyProductTitleAlternate: {
		id: 'connect_third_party_product_title_alternate',
		defaultMessage: '{product} is now available!',
		description:
			'Alternate title shown to prompt users to connect third-party products (not added by admin)',
	},
	connectThirdPartyProductDescription: {
		id: 'connect_third_party_product_description',
		defaultMessage: 'Connect your account to see missing results',
		description: 'Description shown to prompt users to connect third-party products',
	},
	connect: {
		id: 'oauth-message-connect',
		defaultMessage: 'Connect',
		description: 'Message for button to connect the third-party product',
	},
	softBannerTitle: {
		id: 'oauth-banner.soft-banner-title',
		defaultMessage: 'Connect {product} for personalized results',
		description:
			'Title for the optional auth banner shown when admin auth provides public results but user can connect for private results',
	},
	softBannerDescription: {
		id: 'oauth-banner.soft-banner-description',
		defaultMessage:
			'You\u2019re seeing public channels. Connect your account to also search DMs and private channels.',
		description:
			'Description for the optional auth banner explaining that connecting gives access to private content',
	},
});
